import { matchPath } from "react-router-dom";
import { api } from "@/lib/api";

let cache = null;

/** Lijst rondleidingen (directie: alles incl. concepten; anderen: alleen goedgekeurd en alleen als rondleiding_v1 aan staat). */
export async function laadRondleidingen(forceer = false) {
  if (cache && !forceer) return cache;
  const { data } = await api.get("/rondleiding/schermen", { params: { kort: true } });
  cache = data;
  return data;
}

/** Volledige tekst van één scherm (de lijst is kort). */
export async function laadScherm(id) {
  const { data } = await api.get(`/rondleiding/schermen/${id}`);
  return data;
}

/** Gebruik vastleggen (besluit 3-11): geopend, gestart, stap, afgerond of gesloten. */
export function meldGebruik(scherm, gebeurtenis, extra = {}) {
  api.post("/rondleiding/gebruik", { scherm_id: scherm.id, gebeurtenis, ...extra }).catch(() => {});
}

export const wisRondleidingCache = () => { cache = null; };

/** Meest specifieke rondleiding voor dit pad (exact pad wint van een patroon met :id). */
export function schermVoorPad(schermen, pad) {
  const hits = (schermen || []).filter((s) => matchPath({ path: s.pad, end: true }, pad));
  return hits.sort((a, b) => (a.pad.includes(":") ? 1 : 0) - (b.pad.includes(":") ? 1 : 0))[0] || null;
}

/** 'klant-search' → [data-testid="klant-search"]; een echte CSS-selector blijft zoals hij is. */
export function cssVan(selector) {
  const s = String(selector || "").trim();
  return /^[A-Za-z0-9_-]+$/.test(s) ? `[data-testid="${s}"]` : s;
}

export function zichtbaarElement(selector) {
  let el = null;
  try { el = document.querySelector(cssVan(selector)); } catch { return null; }
  if (!el) return null;
  const r = el.getBoundingClientRect();
  const st = window.getComputedStyle(el);
  if ((r.width === 0 && r.height === 0) || st.visibility === "hidden" || st.display === "none") return null;
  return el;
}
